/**
 * Created by chenhao on 2017/12/3.
 */
'use strict';
angular.module('myZonePerInfoforgetPwModule', [])
    .controller('myZonePerInfoForgetPwCtrl', ['$scope', '$validation', '$state', '$interval', 'trsHttpService', 'modalDialog', 'localStorageService', '$sessionStorage', function($scope, $validation, $state, $interval, trsHttpService, modalDialog, localStorageService, $sessionStorage) {
        initStatus();
        initData();


        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo',
            };
            $scope.status = {
                step: 1,
                channel: 2,
                timer: 60,
                sendable: true
            };
            $scope.relations = [];
            $scope.data = {
                // userInfo: localStorageService.get('mlfCachedUser'), // session改变
                userInfo: $sessionStorage.get('mlfCachedUser'),
            };
        }

        function initData() {
            requestData();
        }

        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.info = data; // 信息

                var mobile = data.MOBILE ? '手机号：' + data.MOBILE.slice(0, 3) + '****' + data.MOBILE.slice(7) : '未保留手机号码';
                var email = data.EMAIL ? '邮箱：' + data.EMAIL.slice(0, 2) + '****' + data.EMAIL.slice(6) : '未保留邮箱';
                $scope.relations.push({ 'name': mobile, value: 0, 'opertate': !!data.MOBILE});
                $scope.relations.push({ 'name': email, value: 1, 'opertate': !!data.EMAIL});
                $scope.selectRelation = data.MOBILE ? $scope.relations[0] : $scope.relations[1];
            });
        }

        /**
         * [chooseRelation description] 选择获取验证码的方式
         * @param  {[type]} selectRelation [description]
         * @return {[type]}                [description]
         */
        $scope.chooseRelation = function(selectRelation) {
            $scope.status.getCodeType = selectRelation.value;
            $scope.status.codeAble = selectRelation.opertate;
        };

        /**
         * [getCode description] 获取短信验证码
         * @return {[type]} [description]
         */
        $scope.getCode = function() {
            if (!$scope.status.codeAble) {return;}
            $scope.status.finalType = !$scope.status.getCodeType ? $scope.selectRelation.value : $scope.status.getCodeType;
            var params = {};
            if ($scope.status.finalType == 0) { // 手机
                params = {
                    UserName: $scope.data.userInfo.UserName,
                    Password: $scope.data.userInfo.Password
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/security/sendSMSCode', params, 'post').then(function(data) {
                    if (data.code == 1) {
                        $scope.status.timer = 60;
                        $scope.status.sendable = false;
                        countDown();
                    }
                });
            } else { // 邮箱
                params = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'ResetPassToEmail'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var url = $state.href('front.myzone.personalinfo.entermail');
                    window.open(url);
                });
            }

            function countDown() {
                $scope.timer = $interval(function() {
                    if ($scope.status.timer > 0) {
                        $scope.status.timer--;
                    } else {
                        $interval.cancel($scope.timer);
                        $scope.status.sendable = true;
                    }
                }, 1000);
            }
        };

        $scope.$on('destroy', function() {
            $interval.cancel($scope.timer);
        });

        /**
         * [submit description] 验证码验证
         * @return {[type]} [description]
         */
        $scope.vartifyCode = function() {
            $validation.validate($scope.modifyProInfo).success(function() {
                var params = {
                    serviceid: 'mlf_tenantuploadmanage',
                    methodname: 'checkSMSCode',
                    SMSCODE: $scope.data.vartifyCode
                };
                if ($scope.status.finalType == 0) {
                    params.serviceid = 'mlf_tenantuploadmanage';
                } else {
                    params.serviceid = 'mlf_usermanagement';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.status.step = 2;
                });
            });
        };

        /**
         * [setSuccess description] 设置新密码
         */
        $scope.setPw = function() {
            $validation.validate($scope.setNewPw).success(function() {
                if ($scope.status.newPwd != $scope.status.newPwdTwo) {
                    modalDialog.alertType('两次密码不同', '', 'error', false, '');
                } else {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'ResetPass',
                        NewPassWord: $scope.status.newPwd
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.status.step = 3;
                    });
                }
            });
        };

        /**
         * [checkPwd description]  确认两次密码是否相同
         * @return {[type]} [description]
         */
        $scope.checkPwd = function() {
            $scope.status.pwTip = ($scope.status.newPwd == $scope.status.newPwdTwo);
        };

        /**
         * [entermail description] 跳转到email登录页面
         * @return {[type]} [description]
         */
        $scope.entermail = function() {
            var addr = $scope.info.EMAIL.split('@')[1];
            var url = 'http://mail.' + addr;
            window.open(url);
        };
    }]);
